import React from "react";

import { templates } from "@reactivated";

import { OrderNumberPopup } from "../apps/customer-account/OrderNumberPopup";

export const Template = (
    props: templates.OrderNumberPopupTemplate,
): React.JSX.Element => {
    return <OrderNumberPopup {...props} />;
};
